import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TestState = {
    list: any;
    selected: any;
    filters: {
        searchTerm: string;
        tab: string;
        subCategory: string;
        department: string;
    };
};

let initialState: TestState = {
    list: {},
    selected: {},
    filters: {
        searchTerm: "",
        tab: "tests",
        subCategory: "",
        department: "",
    },
};

const testSlice = createSlice({
    name: "test",
    initialState,
    reducers: {
        listResponse(state, action: PayloadAction<any>) {
            state.list = action.payload;
        },
        getByIdResponse(state, action: PayloadAction<any>) {
            state.selected = action.payload;
        },
        getBySlugResponse(state, action: PayloadAction<any>) {
            state.selected = action.payload;
        },
        setFilters(state, action : PayloadAction<any>){
            state.filters = {...state.filters, ...action.payload}
        },
        resetFilters(state){
            state.filters = {
                searchTerm : "",
                tab : "tests",
                subCategory : "",
                department : ""

            }
        }
    },
});

export const { listResponse, getByIdResponse, getBySlugResponse , setFilters, resetFilters} = testSlice.actions;

export default testSlice.reducer;
